import React from "react";
import { useDispatch } from "react-redux";

import { hideModal } from "../../../store/slices/modal";

const OfferDescriptionModal = ({ modalData }) => {
  const dispatch = useDispatch();
  const closeModal = () => dispatch(hideModal());
  const { description } = modalData;

  return (
    <div className="col-xl-7 col-lg-8 col-md-10">
      <div className="load-add-edit-modal">
        <div className="row">
          <h1 className="large-text mb-4">Carrier Message</h1>
        	<p>{description}</p>
        </div>

        <div className="multiple-btn modal-button offer-description-button">
          <button onClick={closeModal}> Cancel </button>
        </div>
      </div>
    </div>
  );
};

export default OfferDescriptionModal;
